import { useCallback } from "react";
import { useHistory } from "react-router-dom";

import { useRouterProvider } from "2g-router";

export default function useRedirect() {
  const history = useHistory();
  const { getLangPath } = useRouterProvider();

  return useCallback(
    (path, values, { method = "push", state } = {}) => {
      history[method]({ pathname: getLangPath(path, values), state });
    },
    [getLangPath]
  );
}
